import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import { isIE11 } from '../../../utils/NavigatorUtils';
import ExportIcon from './ExportIcon';
import { Button } from '@mui/material';

import { buttonExportStyle } from './ButtonExportStyle';

interface FullTailViewExportButtonProps extends RouteComponentProps {}

// takes an existing path and appends exports
// the filter makes sure there isn't an empty path eg('fleet/123//export)
const createExportPath = (path: string) => path.split('/').filter(Boolean).concat(['export']).join('/');

class FullTailViewExportButton extends React.PureComponent<FullTailViewExportButtonProps> {
  render() {
    if (isIE11) return null;
    return (
      <Button
        color="secondary"
        disableRipple
        sx={{
          ...buttonExportStyle,
          marginLeft: 'auto',
        }}
        onClick={() => {
          const { location, history } = this.props;
          history.push(`/${createExportPath(location.pathname)}`);
        }}
      >
        Export <ExportIcon />
      </Button>
    );
  }
}

export default withRouter(FullTailViewExportButton);
